import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.143 29.635 32.317 13.46a1.571 1.571 0 1 1 2.223 2.223L18.365 31.857H33.43a1.571 1.571 0 0 1 0 3.143H14.567a1.57 1.57 0 0 1-1.103-.457l-.007-.007A1.57 1.57 0 0 1 13 33.43V14.57a1.571 1.571 0 0 1 3.143 0z"
    }
  )
);
var SvgInboundOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var InboundOutlined_default = SvgInboundOutlined;

export { InboundOutlined_default as default };
